// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__-OWza"};